// extracted by mini-css-extract-plugin
export default {"avatar":"LNl59SFxEy4G52qu1BIJh6BeukHcdEP11kAftRiaZeY="};